/**
 * 异常待处理订单详情
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import { Empty, Spin,InputNumber,Button,message} from "antd";
import Lang from "@components/Lang/Lang";
import BtnSelect from '@components/BtnSelect/BtnSelect';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {isEmpty,isEmptyObject,symbolMoneyUtil,toFixed2 } from '@utils/utils';
import Locale from "@utils/locale";
import FormFormat from '@/components/FormFormat/FormFormat';
import IntegerCtrlInput from "@components/Input/IntegerCtrlInput";// 数字组件
import HttpServerAction from '@/api/httpServer.action';
import "./detail.less";
import { ClaimLeft, ClaimRightPlan,ClaimRightHandle } from "@/components/DamageDetail";
const locale = Locale.current();

class ExceptionPendingOrderDetail extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            item:{},
            values:{},
            bankList:[], // 银行卡列表
        }
    }

    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    getCerId(str){
        if(str.length>0) return str.substr(1,str.length);
        return '';
    }
    // 修改索赔类型
    changeClaimType(claimType){
        let {values={}} =this.state;
        values["claimType"] = claimType;
        this.setState({
            values
        })
        // 如果切换到现金模式，获取银行卡列表
        if(claimType == "20"){
            // this.getBankList();
        }
    }

    // 赋值
    setValue(filed,value){
        const {values={},model={}} = this.state;
        let  newValus ={...values}
        const mgPoInfoVO = model.mgPoInfoVO||{};
        newValus[filed] = value;
        if(filed=="isBoxClaim"){
            // 如果是按照整箱赔偿的话   = refundAmountTotal =  sku.pcsPrice * skuCount * skuCapacity * wornBoxQuantity
            let quantity = 0;
            if(value==1){
                quantity= model.wornBoxQuantity * mgPoInfoVO.skuCapacity * mgPoInfoVO.skuCount;
            }else {
                quantity = model.wornQuantity;
            }
            newValus["quantity"] = quantity;
            newValus["refundAmountTotal"] = toFixed2(mgPoInfoVO.pcsPrice * quantity);
            newValus["normalQuantity"] = mgPoInfoVO.quantity - (mgPoInfoVO.claimQuantity||0) - quantity;

        }else if(filed=="wornQuantity"){
            newValus["normalQuantity"] = mgPoInfoVO.quantity - (mgPoInfoVO.claimQuantity||0) - value;
        }
        // else if(filed=="normalQuantity"){
        //     values["wornQuantity"] = values.quantity - value;
        // }
        this.setState({
            values:newValus
        })
    }
    getReg(type,value){
        switch (type) {
            case "formatter":
                return  locale=='ru'?`${value}`.replace(/\d{1,3}(?=(\d{3})+(\.|$))/g,'$& ').replace('.',','):`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            case "parser":
                return locale=='ru'?value.replace(/\s*/g,"").replace(',','.'):value.replace(/\$\s?|(,*)/g, '');
            default:
                return value
        }

    }   // 更新 赔付数量
    updateNum(num,callback){
        let {values={},model={}} = this.state;
        const mgPoInfoVO = model.mgPoInfoVO||{};
        values["quantity"] = num;
        values["wornQuantity"] = num;
        values["normalQuantity"] = 0;
        values["refundAmountTotal"] = toFixed2(mgPoInfoVO.pcsPrice * num);
        this.setState({
            values:values
        })
    }
    getOption(mgPoInfoVO={},quantity=1,sUnit,values={}){
        const {model={}} = this.state;
        let list =  [
            {
                name:'refundAmountTotal',
                cnTitleId:'ZongShouHouTuiKuan',// 总售后退款
                type:'OnlyRender',
                onlyRender:(<div className={"mb_16 bigSize"}>
                    <div className={"mt_4"}>
                        <BtnSelect list={[{
                            code:"2",
                            name:Lang({id:"ShouQuanPeiShen",default:"同意赔偿"})
                        },{
                            code:"3",
                            name:Lang({id:"BuTongYi",default:"不同意"})
                        }]} initValue={mgPoInfoVO.status} callBack={(v)=>this.setValue("status",v)} />
                    </div>
                    <div className={"mt_12 mb_12 flex-item-ver-center"}><span className={"color-red2 mr_2"}>*</span>{Lang({id:"ZongPeiChangJiaZhiJinE",default:"总赔偿价值/金额"})}</div>
                    {/*<div className={"mt_4"}>*/}
                        {/*<BtnSelect list={[{*/}
                            {/*code:"0",*/}
                            {/*name:Lang({id:"AnPoSunShuLiangPeiChang",default:"按破损数量赔偿"})*/}
                        {/*},{*/}
                            {/*code:"1",*/}
                            {/*name:Lang({id:"AnZhengXiangPeiChang",default:"按整箱赔偿"})*/}
                        {/*}]} initValue={values.isBoxClaim} callBack={(v)=>this.setValue("isBoxClaim",v)} />*/}
                    {/*</div>*/}
                    <div className={"mt_4 flex-item-ver-center"}>
                        <div className={"inputAdd"}>
                            <IntegerCtrlInput value={values.quantity}
                                              key={"integerCtrlInput_"+mgPoInfoVO.id}
                                              quantity={1}
                                              minNumber={1} //大于0的整数
                                              maxNumber={values.isBoxClaim==1?(model.wornBoxQuantity*mgPoInfoVO.skuCount*mgPoInfoVO.skuCapacity):model.cdQuantity} // 不能超过当前商申请数量
                                              callbackChange={false}
                                              onChange={(newValue,callback)=>this.updateNum(newValue,callback)} />
                        </div>
                        <div className={"ml_6 font_16 fw_700 color-black"}>{sUnit}<span className={"ml_4 mr_4"}>×</span></div>
                        <InputNumber style={{width:'150px'}}
                            value={values.refundAmount}
                            min={0.01}
                            max={mgPoInfoVO.pcsPrice} // 单价不能超过当前商品PCS价
                            formatter={value => this.getReg("formatter",value)}
                            parser={value => this.getReg("parser",value) }
                            placeholder={Lang({id:"QingShuRuJinE",default:"请输入金额"})}
                            precision={2}
                            onChange={(v)=>this.setValue("refundAmount",v)}
                            addonAfter={mgPoInfoVO.currencySymbol+" / "+sUnit} />
                        <span className={"ml_4 mr_4"}>=</span>
                        <InputNumber style={{width:'150px'}}
                            value={values.refundAmountTotal}
                            min={0.01}
                            max={mgPoInfoVO.pcsPrice*values.quantity}
                            formatter={value => this.getReg("formatter",value)}
                            parser={value => this.getReg("parser",value) }
                            placeholder={Lang({id:"QingShuRuJinE",default:"请输入金额"})}
                            precision={2}
                            onChange={(v)=>this.setValue("refundAmountTotal",v)}
                            addonAfter={mgPoInfoVO.currencySymbol}
                        />
                    </div>
                </div>)
            },
            {
                name:'cause',// 结果说明
                cnTitleId:'JieGuoShuoMing',
                // required: true,
                type:'TextArea',
                minRows: 5,
                maxLength: 512,
            },
        ]
        return list
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    /**
     * 点击确认时 获取表单数据
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#6273
     ***/
    async handleOK(){
        const {values,curBank} = this.state;
        const res = await this.onRefFormFormat.handleOK();
        let postForm = {};
        if(res.success){
            postForm=  res.data;
        }
        if(isEmpty(values.claimType)){
            message.warning(Lang({id:'QingXuanZeShouHouFangAn',default:"请选择售后方案"}));
            return false;
        // }else if(values.claimType=="20" && isEmpty(values.bankCardId)){
        //     message.warning(Lang({id:'QingXuanZeShouKuanYinHangKa',default:"请选择收款银行卡"}));
        //     return false;
        }else if(isEmpty(values.status)){
            message.warning(Lang({id:'QingXuanZePeiChangChuLi',default:"请选择赔偿处理"}));
            return false;
        }else if(isEmpty(values.isBoxClaim)){
            message.warning(Lang({id:'AnPoSunShuLiangPeiChang',default:"按破损数量赔偿"})+" / "+Lang({id:'AnZhengXiangPeiChang',default:"按整箱赔偿"}));
            return false;
        }
        const sUrl =  "/service/mg/sale/claimDemage/audit/submit";
        this.loading(true);
        let postData = {
            ...postForm,
            ...values,
            claimDemageOrderId:Number(this.state.claimDemageOrderId),
        }
        if(curBank&&curBank.id){
            postData.buyerBankCardId=curBank.id;
        }
        HttpServerAction.postHttpAction(sUrl,postData).then((resp)=>this.handleSaveRes(resp.data)).catch(err=>this.handleSaveRes(err));
    }
    handleSaveRes(resData={}){
        this.loading(false);
        const { success, valid,model={}} = resData;
        if (success &&valid) {
            message.success(Lang({id: 'CaoZuoChengGong', default: '操作成功'}))
            const {claimDemageOrderId} = this.state;
            this.getDetail(claimDemageOrderId)
            // 刷新页面
            if(this.props.successBack){
                this.props.successBack();
            }
        }else if(resData.message){
            message.warning(resData.message)
        }else {
            message.warning(Lang({id: 'BaoCunShiBai', default: '操作失败'}));
        }
    }
    /**
     * 查看详情
     * */
    getDetail(){
        if(this.state.claimDemageOrderId){
            const data ={
                claimDemageOrderId:this.state.claimDemageOrderId,
            }
            const sUrl =  "/service/mg/sale/claimDemage/claim-demage-info";
            this.loading(true)
            HttpServerAction.postHttpAction(sUrl,data,).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
        }

    }
    handleRes(resData){
        this.loading(false);
        const { success,valid,model={}} = resData;
        if(success&valid){
            if(model.damageCode){
                const list = __getDictList("claim_demage_order_damage_code");
                const curDamage = list.find(item=>item.code==model.damageCode)||{};
                model.damageCodeName =curDamage.name;
            }
            const mgPoInfoVO = model.mgPoInfoVO || {};
            let {values} = this.state;
            // 回显
            let quantity =0;
            const isBoxClaim = model.isBoxClaim||"0"
            if(isBoxClaim==1){
                quantity= model.wornBoxQuantity * mgPoInfoVO.skuCapacity * mgPoInfoVO.skuCount;
            }else {
                quantity = model.cdQuantity; // wornQuantity
            }
            const refundAmountTotal= toFixed2(mgPoInfoVO.pcsPrice * quantity);
           // const normalQuantity = mgPoInfoVO.quantity - (mgPoInfoVO.claimQuantity||0) - quantity;
            values = {...values,
                claimType:model.claimType,
                isBoxClaim:isBoxClaim,
                // status:model.status,
                quantity: quantity,
                refundAmount: mgPoInfoVO.pcsPrice,
                refundAmountTotal:refundAmountTotal,
                bankCardId:model.bankCardId, // 回显银行卡
            }

            this.setState({
                model:model,
                values:values
            },()=>{
                // if(this.onRefPageMgChild)this.onRefPageMgChild.init();//工作台是读取state数据，所以重新初始化
                // 如果索赔类型是现金，加载银行卡列表
            })
        }
    }
    changeBank(curBank){
        this.setState({curBank:curBank})
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    componentDidMount() {
        const { search } = this.props.location;
        const idDetail = this.getCerId(search);
        this.setState({
            claimDemageOrderId:idDetail,
        },()=>this.getDetail(idDetail))

    }
    render(){
        const { loading, model={}, values={},} = this.state;
        const currPageName = Lang({id: "CangKuFaQi",default: "仓库发起"});
        // values.isBoxClaim=='1'?Lang({id:"Xiang",default:"箱"}):
        const snUit = "PCS",mgPoInfoVO = model.mgPoInfoVO||{},buyerBankCardVO=model.buyerBankCardVO||{};
        return ( <Spin spinning={loading}>
                <CommonBreadcrumb list={[
                    { name:currPageName, link:'/afterSale/warehouseInitiated'},
                    {name:model.demageCode||''}]}></CommonBreadcrumb>
                <div className="damageDetailWrap">
                    {(!isEmptyObject(model))?<div className={'detailBox flex-item font_14 '}>
                            {/* 索赔左侧信息 */}
                            <div className={"wHalf"}>
                                <ClaimLeft model={model} />
                            </div>
                            <div className={"wHalf"}>
                                {/* 售后方案 */}
                                <ClaimRightPlan model={model}
                                                values={values}
                                                changeClaimType={(v)=>this.changeClaimType(v)} changeBank={(v) => this.changeBank(v)} />

                                <div className={"borderInfoCard mt_16"}>
                                    <div className={"black89 fw_700 font_16"}>{Lang({id:"PeiShenChuLi",default:"赔偿处理"})}</div>
                                    {/*    表单 start
                                    /**
                                    * 索赔单状态  Status  * 审核中  "1"| 审核通过 "2"| 已驳回 "3"| 撤销 "4"| 已赔付 "5"| 已失效 "6"| 待处理 "7"| 已关闭 "8"
                                    *            StatusMg * 审核中  "1"| 审核通过 "2"| 已驳回 "3"| 已撤销 "4"| 已赔付 "5"| 已失效 "6"| 待汇款 "7"| 已关闭 "8" | 已发起 9
                               */}
                                    {model&&model.statusMg=="1"?<FormFormat onRef={this.onRefForm}
                                                                options={this.getOption(mgPoInfoVO,values.quantity,snUit,values)}
                                                                formItemLayout={null}
                                                                formLayout = "vertical"
                                                                initialValues={mgPoInfoVO} />:
                                        <ClaimRightHandle model={model} snUit={snUit} />
                                    }
                                </div>
                                {model&&model.statusMg=="1"&&<div className={"mt_24"}>
                                    <Button type="primary" size={"large"} onClick={()=>this.handleOK()} style={{width:"100%"}}>
                                        {Lang({id:"TiJiaoShouHouChuLi",default:"提交售后处理"})}
                                    </Button>
                                </div>}
                            </div>

                    </div>:(<Empty description={Lang({id: "WeiZhaoDaoFuHeTiaoJianDeJiLu",default: "未找到符合条件的记录"})} />)}
                </div>
        </Spin> )
    }
}
export default ExceptionPendingOrderDetail;
